import { render, staticRenderFns } from "./TeamPlanExpiryInfo.vue?vue&type=template&id=35ae054e&scoped=true&"
import script from "./TeamPlanExpiryInfo.vue?vue&type=script&lang=js&"
export * from "./TeamPlanExpiryInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeamPlanExpiryInfo.vue?vue&type=style&index=0&id=35ae054e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae054e",
  null
  
)

export default component.exports